export const GET_ALL_LEADS = "GET_ALL_LEADS"
export const GET_PROPOSAL_LEADID_BASED = "GET_PROPOSAL_LEADID_BASED"
export const GET_QUOTES_LEADID_BASED = "GET_QUOTES_LEADID_BASED"
export const GET_PAYMENT_USERID_BASED = "GET_PAYMENT_USERID_BASED"
export const GET_POLICY_DETAILS = "GET_POLICY_DETAILS"
export const GET_SINGLE_PAID_POLICY = "GET_SINGLE_PAID_POLICY"
export const GET_PAMENT_BASED_ON = "GET_PAMENT_BASED_ON"